exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".board-frame{height:500px;width:500px;border:2px solid #f5f5f5;flex-wrap:wrap}.board-frame,.board-tile{display:flex;box-sizing:border-box}.board-tile{width:33.33333%;height:33.33%;justify-content:center;align-items:center;border:1px solid #dcdcdc;font-size:1.25rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-605b1d90","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Board.vue
// module id = 18
// module chunks = 0